/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivBatchImportMileageDtoGen,
  MrfiktivBatchImportMileageResultViewModelGen,
  MrfiktivCreateBlueprintDtoGen,
  MrfiktivCreateVehicleDocumentDtoGen,
  MrfiktivCreateVehicleDtoGen,
  MrfiktivDeleteVehicleViewModelGen,
  MrfiktivDuplicateVehicleNumberplateViewModelGen,
  MrfiktivDuplicateVehicleVinViewModelGen,
  MrfiktivExceptionViewmodelGen,
  MrfiktivPageViewModelGen,
  MrfiktivRegenerateNumberplateNormalizedResultViewModelGen,
  MrfiktivUpdateBlueprintDtoGen,
  MrfiktivUpdateVehicleDtoGen,
  MrfiktivUpdateVehicleRegistrationDtoGen,
  MrfiktivUpdateVehicleStateDtoGen,
  MrfiktivVehicleControllerCreateBatchPayloadGen,
  MrfiktivVehicleControllerCreateContractPayloadGen,
  MrfiktivVehicleControllerDeleteParamsGen,
  MrfiktivVehicleControllerGetAllParamsGen,
  MrfiktivVehicleControllerGetDuplicateNumberplatesParamsGen,
  MrfiktivVehicleControllerGetDuplicateVinsParamsGen,
  MrfiktivVehicleControllerUpdateContractPayloadGen,
  MrfiktivVehicleViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Vehicle<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerSyncIndex
   * @summary Syncs indexes of vehicle
   * @request POST:/syncindexes
   * @response `200` `void` Sync result
   * @response `400` `void` Bad request.
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerSyncIndex = (params: RequestParams = {}) =>
    this.http.request<void, void | MrfiktivExceptionViewmodelGen>({
      path: `/syncindexes`,
      method: "POST",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerCreate
   * @summary (VEHICLE-CREATE) Creates a vehicle
   * @request POST:/partner/{partnerId}/vehicle
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` the created vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerCreate = (partnerId: string, data: MrfiktivCreateVehicleDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerGetAll
   * @summary (VEHICLE-READ) Get all vehicles
   * @request GET:/partner/{partnerId}/vehicle
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivVehicleViewModelGen)[] })`
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerGetAll = (
    { partnerId, ...query }: MrfiktivVehicleControllerGetAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      MrfiktivPageViewModelGen & { data?: MrfiktivVehicleViewModelGen[] },
      MrfiktivExceptionViewmodelGen
    >({
      path: `/partner/${partnerId}/vehicle`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerCreateBatch
   * @summary (VEHICLE-CREATE) Creates a vehicle
   * @request POST:/partner/{partnerId}/vehicle/batch
   * @secure
   * @response `201` `(MrfiktivVehicleViewModelGen)[]` (VEHICLE - CREATE) the created vehicles
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerCreateBatch = (
    partnerId: string,
    data: MrfiktivVehicleControllerCreateBatchPayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen[], MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/batch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerBatchImportMileages
   * @summary (VEHICLE-CREATE) Batch import mileages for vehicles by VIN or vehicleId
   * @request POST:/partner/{partnerId}/vehicle/mileage/batch
   * @secure
   * @response `201` `MrfiktivBatchImportMileageResultViewModelGen` Batch import result
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerBatchImportMileages = (
    partnerId: string,
    data: MrfiktivBatchImportMileageDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBatchImportMileageResultViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/mileage/batch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerGetDuplicateVins
   * @summary (VEHICLE-READ) Get duplicate VINs for a partner
   * @request GET:/partner/{partnerId}/vehicle/duplicates
   * @secure
   * @response `200` `(MrfiktivDuplicateVehicleVinViewModelGen)[]` Duplicate VINs
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerGetDuplicateVins = (
    { partnerId, ...query }: MrfiktivVehicleControllerGetDuplicateVinsParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDuplicateVehicleVinViewModelGen[], MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/duplicates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerGetDuplicateNumberplates
   * @summary (VEHICLE-READ) Get duplicate normalized numberplates for a partner
   * @request GET:/partner/{partnerId}/vehicle/duplicates/numberplate
   * @secure
   * @response `200` `(MrfiktivDuplicateVehicleNumberplateViewModelGen)[]` Duplicate normalized numberplates
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerGetDuplicateNumberplates = (
    { partnerId, ...query }: MrfiktivVehicleControllerGetDuplicateNumberplatesParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDuplicateVehicleNumberplateViewModelGen[], MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/duplicates/numberplate`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerRegenerateNumberplateNormalized
   * @summary (VEHICLE-UPDATE) Regenerate normalized numberplates for all vehicles of a partner
   * @request POST:/partner/{partnerId}/vehicle/numberplate/regenerate-normalized
   * @secure
   * @response `201` `MrfiktivRegenerateNumberplateNormalizedResultViewModelGen` Counts of matched and modified documents
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerRegenerateNumberplateNormalized = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRegenerateNumberplateNormalizedResultViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/numberplate/regenerate-normalized`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerGetOne
   * @summary (VEHICLE-READ) Get a vehicle by vehicleId
   * @request GET:/partner/{partnerId}/vehicle/{vehicleId}
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` Get a vehicle by vehicleId
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerGetOne = (partnerId: string, vehicleId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerUpdate
   * @summary (VEHICLE-UPDATE) Update a vehicle
   * @request PUT:/partner/{partnerId}/vehicle/{vehicleId}
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` The updated vehicle.
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerUpdate = (
    partnerId: string,
    vehicleId: string,
    data: MrfiktivUpdateVehicleDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerDelete
   * @summary (VEHICLE-DELETE) Delete a vehicle
   * @request DELETE:/partner/{partnerId}/vehicle/{vehicleId}
   * @secure
   * @response `201` `MrfiktivDeleteVehicleViewModelGen` The deleted (or soft deleted) record. blockingRefs lists the refs that prevented a hard delete.
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerDelete = (
    { partnerId, vehicleId, ...query }: MrfiktivVehicleControllerDeleteParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDeleteVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}`,
      method: "DELETE",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerUpdateVehicleState
   * @summary (VEHICLE-UPDATE) Update the state of a vehicle
   * @request PATCH:/partner/{partnerId}/vehicle/{vehicleId}/state
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` Vehicle with updated state
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerUpdateVehicleState = (
    partnerId: string,
    vehicleId: string,
    data: MrfiktivUpdateVehicleStateDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/state`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerUpdateRegistration
   * @summary (VEHICLE-UPDATE) Update a vehicle registration
   * @request PUT:/partner/{partnerId}/vehicle/{vehicleId}/registration
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` Id of created operation
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerUpdateRegistration = (
    partnerId: string,
    vehicleId: string,
    data: MrfiktivUpdateVehicleRegistrationDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/registration`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerRestoreArchived
   * @summary (ADMIN) Restores an archived vehicle back to active
   * @request POST:/partner/{partnerId}/vehicle/{vehicleId}/restore
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` The restored vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerRestoreArchived = (partnerId: string, vehicleId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/restore`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerRestoreSoftDeleted
   * @summary (ADMIN) Restores a soft deleted vehicle back to active
   * @request POST:/partner/{partnerId}/vehicle/{vehicleId}/restore-deleted
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` The restored vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerRestoreSoftDeleted = (partnerId: string, vehicleId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/restore-deleted`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerCreateDocument
   * @summary (VEHICLE-CREATE) Creates a document for a vehicle
   * @request POST:/partner/{partnerId}/vehicle/{vehicleId}/document
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` the created vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerCreateDocument = (
    partnerId: string,
    vehicleId: string,
    data: MrfiktivCreateVehicleDocumentDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/document`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerUpdateDocument
   * @summary (VEHICLE-UPDATE) Updates a document for a vehicle
   * @request PUT:/partner/{partnerId}/vehicle/{vehicleId}/document/{documentId}
   * @secure
   * @response `200` `MrfiktivVehicleViewModelGen` the created vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerUpdateDocument = (
    partnerId: string,
    vehicleId: string,
    documentId: string,
    data: MrfiktivCreateVehicleDocumentDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/document/${documentId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerDeleteDocument
   * @summary (VEHICLE-DELETE) Deletes a document of a vehicle
   * @request DELETE:/partner/{partnerId}/vehicle/{vehicleId}/document/{documentId}
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` the vehicle with the deleted document
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerDeleteDocument = (
    partnerId: string,
    vehicleId: string,
    documentId: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/document/${documentId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerCreateContract
   * @summary (VEHICLE-CREATE) Creates a vehicle contract
   * @request POST:/partner/{partnerId}/vehicle/{vehicleId}/contract
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` the created vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerCreateContract = (
    partnerId: string,
    vehicleId: string,
    data: MrfiktivVehicleControllerCreateContractPayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/contract`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerUpdateContract
   * @summary (VEHICLE-Update) Update a vehicle contract
   * @request PUT:/partner/{partnerId}/vehicle/{vehicleId}/contract/{contractId}
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` the updated vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerUpdateContract = (
    partnerId: string,
    vehicleId: string,
    contractId: string,
    data: MrfiktivVehicleControllerUpdateContractPayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/contract/${contractId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerDeleteContract
   * @summary (VEHICLE-Update) Update a vehicle contract
   * @request DELETE:/partner/{partnerId}/vehicle/{vehicleId}/contract/{contractId}
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` the updated vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerDeleteContract = (
    partnerId: string,
    vehicleId: string,
    contractId: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/contract/${contractId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerCreateBlueprint
   * @summary (VEHICLE-CREATE) Creates a blueprint for a vehicle
   * @request POST:/partner/{partnerId}/vehicle/{vehicleId}/blueprint
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` the created vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerCreateBlueprint = (
    partnerId: string,
    vehicleId: string,
    data: MrfiktivCreateBlueprintDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/blueprint`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerUpdateBlueprint
   * @summary (VEHICLE-UPDATE) Updates a blueprint for a vehicle
   * @request PUT:/partner/{partnerId}/vehicle/{vehicleId}/blueprint/{blueprintId}
   * @secure
   * @response `200` `MrfiktivVehicleViewModelGen` the created vehicle
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerUpdateBlueprint = (
    partnerId: string,
    vehicleId: string,
    blueprintId: string,
    data: MrfiktivUpdateBlueprintDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/blueprint/${blueprintId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags vehicle
   * @name VehicleControllerDeleteBlueprint
   * @summary (VEHICLE-DELETE) Deletes a blueprint of a vehicle
   * @request DELETE:/partner/{partnerId}/vehicle/{vehicleId}/blueprint/{blueprintId}
   * @secure
   * @response `201` `MrfiktivVehicleViewModelGen` the vehicle with the deleted blueprint
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `415` `MrfiktivExceptionViewmodelGen` Unsupported Media Type Error
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  vehicleControllerDeleteBlueprint = (
    partnerId: string,
    vehicleId: string,
    blueprintId: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVehicleViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/vehicle/${vehicleId}/blueprint/${blueprintId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
}
